$(function(){
  setupClickOpen();
  setupActionShow();
  setupExpandButton();
  setupShowExpand();
  setupToggling();
})

function setupClickOpen(){
  $('.click-open-button').each(function(){
    var t = $(this);
    var target = $(t.data('cotarget'));
    t.click(function(e){
      e.preventDefault();
      target.animate({
        maxHeight: 2000
      },{
        duration: 1200,
        easing: 'linear'
      });
    });
  });
}

function setupActionShow(){
  $('.btn-action-show').click(function(){
    var target = $(this).data('target');
    $(target).toggleClass('ph-show');
    if($(this).hasClass('btn-action-hideAfter'))$(this).addClass('hidden');
  });
}

function setupExpandButton() {
  $('.expand-btn').click(function(){
    var exp = $(this).closest('.expandable');
    exp.toggleClass('expanded');
    if(exp.hasClass('expanded')){
      exp.find('.onlyCollapsed').hide();
      exp.find('.onlyExpanded').show();
      exp.find('.style-on-expanded').each(function(){
        $(this).prop('style', $(this).data('soe'));
      });
    } else{
      exp.find('.onlyCollapsed').show();
      exp.find('.onlyExpanded').hide();
      exp.find('.style-on-collapsed').each(function(){
        $(this).prop('style', $(this).data('soc'));
      });
    }
  });
  if(typeof levelId !== "undefined"){ 
    registerGAEvent('.levelTheory .expand-btn', 'click', 'expandTheoryClick', levelId, 'Theory expanded by click', true)
  }
}

function setupShowExpand(){
  $('.show-expand').bind('click', function(e) {
    e.preventDefault();
    var $target = $($(this).data('target'));
    if(!$target.data('stayexpanded')) $target.toggleClass('show');
    if($(this).data('stayexpanded')) $target.data('stayexpanded', true);
    if(typeof $(this).data('scrolltotarget') !== 'undefined' && ($target.hasClass('show') || $target.data('stayexpanded')) && $(this).data('scrolltotarget').toString() == 'true') scrollToTarget($target);
    else if(typeof $(this).data('scrolltotarget') !== 'undefined') scrollToTarget($($(this).data('scrolltotarget')));
    var $push = $($target.data('push'));
    if ($push && typeof $push !== 'undefined' && typeof $push.css('margin-top') !== 'undefined'){
      var pushMargin = parseInt($push.css('margin-top').replace('px', ''));
      pushMargin += $target.height();
      $push.css('margin-top', pushMargin + 'px');
      if($(this).hasClass('hide-after')) $(this).css({display: 'none'});
    }
  });
} 

function setupToggling() {
  $('a.toggleElement').click(function(e) {
    e.preventDefault();
    $('#'+  $(this).attr('data-elementToToggle')).toggleClass('hidden');
    
    if ($(this).attr('data-toggleLinkText')) {  // toggle text of the clicked link
      var linkText = $(this).text();
      $(this).text($(this).attr('data-toggleLinkText'));
      $(this).attr('data-toggleLinkText', linkText);
    }
  });
}
